import { useQuery } from '@tanstack/react-query';
import { getUrl } from '../../App';
import { TeamCard } from '@shared/components/TeamCard/TeamCard';
import styles from './TeamStatsOverView.module.css';

const fetch_teams = async () => {
    const response = await fetch(`${getUrl()}/api/teams/`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

const fetch_games = async () => {
    const response = await fetch(`${getUrl()}/api/games/?is_testgame=false`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}


const TeamStatsOverView = ({ }) => {
    const teams = useQuery({
        queryKey: ['teams'],
        queryFn: () => fetch_teams(),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    const games = useQuery({
            queryKey: ['games'], queryFn: () => fetch_games(),
            staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
            cacheTime: 5 * 60 * 1000,
        });

    if (teams.isError) {
        return <div>Error fetching teams: {teams.error.message}</div>;
    }

    if (teams.isLoading) {
        return (
            <div className={styles.view_content}>
                <div className="panel-header">
                    <h3>TeamView</h3>
                </div>
            </div >
        )
    }
    const gameCount = (team_id) => {
        if (!games || !games.data) return 0;

        return games.data.filter((game) => 
            (game.team1 === team_id || game.team2 === team_id) && game.half === "half1"
        ).length;
    };
   
    return (
        <div className={styles.view_content}>
            <div className="panel-header">
                <h3>Team View</h3>
            </div>
            <div className={styles.projects_section}>
                <div className={`${styles.project_boxes} ${styles.jsGridView}`}>
                    {teams.data.length > 0 ? (
                        <>
                            {teams.data.filter(team => team.team_id != 0).map((team) => (
                                <TeamCard
                                    team={team}
                                    game_count = {gameCount(team.id)}
                                    key={team.name}
                                ></TeamCard>
                            ))}
                        </>
                    ) : (
                        <div className={styles.emptyState}>
                            No events found
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TeamStatsOverView;